// App switcher calls show() for every route, including before a customer
// profile has a Permissions map. `user?.Permissions[variant]` still throws
// `reading 'stc'` when the user exists and Permissions does not: optional
// chaining stops at user, and the index is applied to undefined.

export function customerPortalVariantVisible(user, variant) {
    const permissions = user?.Permissions;
    const variantPermissions = permissions == null ? undefined : permissions[variant];
    if (!variantPermissions) return false;
    return Object.values(variantPermissions).some(permission => permission === true);
}
